import ArticleBox from '@theme/components/content/ArticleBox'
import Loader from '@theme/components/utils/Loader'
import LoadingMixin from '~/mixins/LoadingMixin'
import PaginatedMixin from '~/mixins/PaginatedMixin'
import Pagination from '@theme/components/molecule/Pagination'
import UtilityGridMixin from '@/mixins/UtilityGridMixin'
import eventDefinitions from '~/events/eventDefinitions'

export default {
  components: {
    ArticleBox,
    Loader,
    Pagination,
  },
  mixins: [LoadingMixin, PaginatedMixin, UtilityGridMixin],
  data() {
    return {
      articles: this.initArticles,
      columnGridClass: '',
      scrollToTop: false,
    }
  },
  props: {
    author: {
      type: Object,
      default: null,
    },
    initArticles: {
      type: Array,
      required: true,
    },
    category: {
      type: Object,
      required: false,
    },
    isSearch: {
      type: Boolean,
      default: false,
    },
    paginationAnchor: {
      type: String,
      required: true,
    },
    total: Number,
  },
  mounted() {
    this.columnGridClass = this.computeColumnClass(this.$themeSettings.components.ArticleList.perLine)
  },
  methods: {
    async changePage(page) {
      this.startLoading()
      this.page = Number(page) || 0
      let data
      const payload = {
        page: this.page,
        perPage: this.perPage,
      }
      if (this.isSearch) {
        this.$store.dispatch('search/CHANGE_QUERY', {
          location: 'catalog',
          query: this.$route.query.s,
          page: this.page,
        })
        this.$eventBus.$emit(eventDefinitions.SEARCH.QUERY, {
          location: 'catalog',
          query: this.$route.query.s,
        })
      } else {
        if (this.author) {
          data = await this.$store.dispatch('article/LOAD_ARTICLES_BY_AUTHOR', {
            ...payload,
            authorId: this.author._id,
          })
        } else if (this.category) {
          const { __typename, _id } = this.category || {}
          if (__typename === 'article_tag') {
            data = await this.$store.dispatch('article/LOAD_TAG_ARTICLES', { ...payload, tagId: _id })
          } else {
            data = await this.$store.dispatch('article/LOAD_CATEGORY_ARTICLES', {
              ...payload,
              categoryId: _id,
            })
          }
        } else {
          data = await this.$store.dispatch('article/LOAD_ARTICLES', payload)
        }
        this.articles = data.entities
      }
      this.$router.push({
        path: this.$route.path,
        query: { ...((this.$route || {}).query || {}), p: this.page === 0 ? undefined : this.page },
      })
      if (this.scrollToTop) {
        this.$scrollTo(window.document.body)
      }
      this.stopLoading()
    },
  },
  watch: {
    '$route.query.p': function(page) {
      if (!isNaN(page) && this.page !== page) {
        this.changePage(page)
      }
    },
    initArticles: function(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.articles = newVal
        this.page = 0
      }
    },
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.perPage)
    },
  },
}
